import React, { useRef, useEffect } from 'react'
import { translate } from 'react-i18next'
import ym from 'react-yandex-metrika'
import { Helmet } from 'react-helmet'
import './style.css'

import Image1 from './assets/1.png'
import Image2 from './assets/2.png'
import PDF from './assets/document.png'
import Presentation from './assets/clockwork.pdf'
import Mobile from './assets/mobile.png'

import Feedback from '../../Feedback'

const Intro = ({ t }) => {

    const preview = useRef(null)
    const image1 = useRef(null)
    const image2 = useRef(null)
    const word = useRef(null)

    const halfX = document.documentElement.clientWidth / 2
    const halfY = document.documentElement.clientHeight / 2

    const words = [t('intro.words.marketing'), t('intro.words.design'), t('intro.words.development'), t('intro.words.analytics')]

    useEffect(() => {
        document.body.classList.add('intro')

        ym('hit', '/')

        preview.current.classList.add('intro__preview-hide')
        setTimeout(() => {
            preview.current.classList.add('intro__preview-none')
            loopWords(words).then(() => {})
        }, 1500)

        window.addEventListener('mousemove', listener, false)

        return () => {
            document.body.classList.remove('intro')
            window.removeEventListener('mousemove', listener, false)
            clearTimeout(timeout)
        }
    }, [])

    const loopWords = async (w) => {
        let total = 0
        for(let i = 0; i < w.length; i++) {
            await sleep(() => {

            }, total).then(() => {
                if(word.current) {
                    word.current.innerHTML = ""
                    loop(w[i])

                    if (i === 0)
                        total += w[i].length * 150 + 500
                    else if (i === 1)
                        total += w[i].length * 150 - 500
                    else if (i === 2)
                        total += w[i].length * 150 - 1000
                    else if (i === 3)
                        total += w[i].length * 150 + 1500
                }
            })
        }
    }

    const loop = async (w) => {
        for(let i = 0; i < w.length; i++) {
            await sleep(() => {

            }, 150).then(() => {
                if(word.current)
                    word.current.innerHTML += w[i]
            })
        }
    }

    const sleep = async (fn, ms) => {
        await timeout(ms)
        return fn
    }

    function timeout(ms = 250) {
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    const listener = ({ pageX, pageY }) => {
        const offsetX1 = Math.ceil((pageX - halfX) / 16)
        const offsetY1 = Math.ceil((pageY - halfY) / 16)

        const offsetX2 = Math.ceil((pageX - halfX) / 8)
        const offsetY2 = Math.ceil((pageY - halfY) / 8)

        image1.current.style.marginRight = `${ offsetX1 }px`
        image1.current.style.marginTop = `-${ offsetY1 }px`

        image2.current.style.marginRight = `${ offsetX2 }px`
        image2.current.style.marginTop = `-${ offsetY2 }px`
    }

    return (
        <main className="app__content--intro">

            <Helmet>
                <title>{ t('intro.title') }</title>
            </Helmet>

            <section className="intro--wrapper">
                <div className="intro__description">
                    <p className="intro__description__studio">{ t('intro.studio') } <span>clockwork</span></p>
                    <p className="intro__description__heading">{ t('intro.heading.text') }<br /><span className="not-blue" dangerouslySetInnerHTML={{ __html: t('intro.heading.is') }} /> <span ref={ word } /></p>
                    <div className="intro__description__awards">
                        <a href="https://ratingruneta.ru/apps/krasnoyarsk/"
                           target="_blank"
                           className="intro__description__award--blue"
                           rel="nofollow noopener noreferrer">
                            <img
                                src="https://images.cmsmagazine.ru/diff/cms-badges-generated/apps_global/21365/8237a3e226482d1abca465f778ba03fa_badge_2b7f0e0f274cd5.png"
                                alt="Рейтинг разработчиков мобильных приложений Красноярска" />
                        </a>

                        <a href="https://ratingruneta.ru/apps/ios/krasnoyarsk/"
                           target="_blank"
                           className="intro__description__award--red"
                           rel="nofollow noopener noreferrer">
                            <img
                                src="https://images.cmsmagazine.ru/diff/cms-badges-generated/apps_global/21365/729c892ccddc4d37800d085a2ede64df_badge_423befdb6b2118.png"
                                alt="Рейтинг разработчиков приложений для iOS, Красноярск" />
                        </a>
                    </div>
                    <div className="intro__description__presentation">
                        <p>{ t('intro.presentation.text') } <strong>Web</strong>, <strong>iOS</strong> { t('and') } <strong>Android</strong></p>
                        <a href={ Presentation } download="clockwork" className="intro__description__presentation__link">
                            <span>{ t('intro.presentation.link') }</span>
                            <img src={ PDF } alt="Презентация проектов Clockwork" />
                        </a>
                    </div>
                </div>

                <div className="intro__paralax">
                    <img ref={ image1 } src={ Image1 } className="intro__paralax__image1" alt="Tommy House Mobile Application" />
                    <img ref={ image2 } src={ Image2 } className="intro__paralax__image2" alt="Tommy House Mobile Application" />
                </div>
            </section>

            <section className="intro__feedback">
                <div className="intro__feedback__image">
                    <img src={ Mobile } alt="Разработка сатов и мобильных приложений Clockwork" />
                </div>
                <Feedback />
            </section>

            <div className="intro__preview" ref={ preview }>
                <p>clockwork</p>
            </div>

        </main>
    )

}

export default translate('translations')(Intro)



// WEBPACK FOOTER //
// ./src/Pages/Intro/index.js